export const track = (event, rest) => {
  if (window.clarity && event === "checkout_started") {
    window.clarity("set", "paymentMethod", rest.which_checkout);
  }
};

export default track;
